import { mapActions } from "vuex";
import { mixin as clickaway } from "vue-clickaway";
import { chapters } from "../helpres";

export default {
    mixins: [clickaway, chapters],
    name: "video-provider-youtube",
    props: {
        data: {},
    },
    data() {
        return {
            currentTime: Number(this.$props.data.currentTime) || 0,
            volume: this.$props.data.volume || 1,
            options: {
                playsinline: true,
                clickToPlay: true,
                debug: false,
                settings: ["quality", "speed"],
                keyboard: { focused: true, global: true },
            },

            selectedSpeed: 1,
            speedList: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2],

            activeItem: null,

            isShowChapters: false,
            isShowSettings: false,
        };
    },

    created() {
        this.$bus.$on("enter-chapter", ({ video, chapter }) => {
            this.$bus.$emit("event-select-video", video);
            this.changeChapter(chapter);
        });
    },
    mounted() {
        const player = this.$refs.plyr.player;
        let content_id = this.data.id;

        this.$refs.plyr.$el.focus();

        if (content_id) {
            player.on("ready", () => {
                if (this.currentTime) {
                    localStorage.setItem(`_dmvideo_${content_id}`, this.currentTime);
                }
            });

            if (this.volume) {
                player.volume = this.volume;
            }

            let lastRequestTime = -30;

            player.on("timeupdate", async () => {
                this.currentTime =
                    player.currentTime > 0
                        ? player.currentTime
                        : localStorage.getItem(`_dmvideo_${content_id}`);

                const payload = {
                    content_id,
                    volume: this.volume.toString(),
                    current_time: this.currentTime.toString(),
                };

                localStorage.setItem(`_dmvideo_${content_id}`, this.currentTime);

                const currentTime = player.currentTime;
                const roundedTime = Math.round(currentTime * 10) / 10;

                if (roundedTime % 30 === 0 && roundedTime !== lastRequestTime) {
                    if (Math.abs(currentTime - roundedTime) < 0.2) {
                        await this.updateVideoSettings(payload);
                        lastRequestTime = roundedTime;
                    }
                }
            });

            player.on("volumechange", async () => {
                this.volume = player.volume;

                const payload = {
                    content_id,
                    volume: this.volume.toString(),
                    current_time: this.currentTime.toString(),
                };

                await this.updateVideoSettings(payload);
            });
        }
    },
    methods: {
        ...mapActions({
            updateVideoSettings: "courses/UPDATE_VIDEO_SETTINGS",
        }),

        onTouchPause() {
            let elVideo = document.getElementById("video");

            // if (elVideo.classList.contains("has-pause")) {
            //     this.$refs.plyr.player.play();
            // }

            if (elVideo.classList.contains("has-play")) {
                this.$refs.plyr.player.pause();
            }
        },

        getYoutubeId(url) {
            const regExp =
                /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
            const match = url.match(regExp);
            return match && match[7].length === 11 ? match[7] : false;
        },
    },
};
